import { Typography } from '@mui/material';
import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiService } from '../../services/ApiServiceProvider';
import { useStorage } from '../../services/StorageProvider';
import SnackbarAlert, { Severity } from '../alert/SnackbarAlert';

export const ThankYouView = () => {
  const { t } = useTranslation();
  const { storage } = useStorage();
  const apiService = useApiService();
  const [retrieving, setRetrieving] = useState(false);
  const [prolificStudyId, setProlificStudyId] = React.useState<string | null>(null);
  const [displayError, setDisplayError] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [snackbarContent, setSnackbarContent] = useState<ReactNode>();
  const [snackbarSeverity, setSnackbarSeverity] = useState<Severity>('info');
  const prolificInformation: any = storage.participant?.prolificInformation;

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const showSnackbar = (title: string, content: ReactNode, severity: Severity) => {
    setSnackbarTitle(title);
    setSnackbarContent(content);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const isProlificParticipant = () => {
    return prolificInformation && prolificInformation.isProlific?.toLowerCase() === 'yes' && (prolificInformation?.prolificId ?? '').length > 0;
  };

  useEffect(() => { 
    if (!prolificInformation) {
      return;
    }

    if (isProlificParticipant()) {
      setRetrieving(true);
      apiService.getProlificStudyId(prolificInformation.id).then((prolificStudyId: any) => {
        setProlificStudyId(prolificStudyId);
        setRetrieving(false);
  
        if(!prolificStudyId) {
          setDisplayError(true);
          showSnackbar('Not found','Unable to retrieve your Prolific study ID.','error');
        }
      })
      .catch((error: any) => {
        console.error('Error retrieving Prolific study ID:', error)
        setRetrieving(false);
        setDisplayError(true);
        showSnackbar('Error', error?.message || 'An error occurred while retrieving Prolific study ID.', 'error');
      });
    }
  }, [apiService, prolificInformation]);

  return (
    <>
      <Typography variant="h4" component='h1' id="main-heading" tabIndex={-1}>{t('All tasks completed')}</Typography>
      <div style={{ textAlign: 'center' }}>
        <img src="/assets/images/b2ai-thank-you.jpg" alt="Thank you" style={{maxHeight: '30rem'}} />
      </div>
      {isProlificParticipant() && prolificStudyId ? (
        <Typography variant="h5" component="div" style={{ marginTop: '2rem' }}>
          {t('Your Prolific study ID is')}: {prolificStudyId}
        </Typography>
      ) : (
        retrieving ? 
          <Typography variant="h5" component="div" style={{ marginTop: '2rem' }}>
            {t('Retrieving Prolific study ID...')}
          </Typography>
         : null
      )}

      {displayError && (
        <SnackbarAlert
          open={snackbarOpen}
          title={snackbarTitle}
          severity={snackbarSeverity}
          content={snackbarContent}
          vertical='top'
          onClose={handleSnackbarClose}
        />
      )}
    </>
  );
}
